import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from 'src/app/security/auth.guard';
import { LoginGuard } from 'src/app/security/login.guard';
// import { PurchaseModule } from './routes/purchase/purchase.module';
// import { PurchaseComponent } from './routes/purchase/components/purchase/purchase.component';
// import { OrderModule } from './routes/order/order.module';
// import { SettingModule } from './routes/setting/setting.module';
// import { RegisterModule } from './routes/register/register.module';
// import { SignInModule } from './routes/sign-in/sign-in.module';
// import { ForgetPasswordModule } from './routes/forget-password/forget-password.module';
// import { CheckEmailModule } from './routes/check-email/check-email.module';
// import { CheckEmailComponent } from './routes/check-email/components/check-email/check-email.component';
// import { EmailVerificationModule } from './routes/email-verification/email-verification.module';
// import { EmailVerficationComponent } from './routes/email-verification/components/email-verfication/email-verfication.component';
// import { ResetPasswordComponent } from './routes/reset-password/components/reset-password/reset-password.component';
// import { ResetPasswordModule } from './routes/reset-password/reset-password.module';
// import { RegisterComponent } from './components/users/register/register.component';
import { UnauthorizedModule } from './routes/unauthorized.module';
import { AuthorizedModule } from './routes/authorized.module';
import { UnauthorizedComponent } from './routes/components/unauthorized/unauthorized.component';
import { AuthorizedComponent } from './routes/components/authorized/authorized.component';
import { MobilePaymentModule } from './components/mobile-payment/mobile-payment.module';
import { UserModule } from './routes/user/user.module';
import { PrivacyModule } from './routes/privacy/privacy.module';
import { PolicyModule } from './routes/policy/policy.module';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthGuard],
    component: AuthorizedComponent,
    loadChildren() {
      return AuthorizedModule
    },
    data: {
      animation: 'authorized'
    }
  },
  { path: 'load-m-payment/:id', loadChildren: () => MobilePaymentModule },
  {
    path: 'auth',
    canActivate: [LoginGuard],
    component: UnauthorizedComponent,
    loadChildren() {
      return UnauthorizedModule
    },
    data: {
      animation: 'unauthorized'
    }
  },
  {
    path: 'user',
    canActivate: [LoginGuard],
    loadChildren() {
      return UserModule
    }
  },
  {
    path: 'privacy',
    loadChildren() {
      return PrivacyModule
    }
  },
  {
    path: 'policy',
    loadChildren() {
      return PolicyModule
    }
  },
  { path: '**', redirectTo: 'auth/login', pathMatch: 'full' }
  // { path: 'logged', component: AppComponent, canActivate: [AuthGuard] },
  // { path: 'purchases', loadChildren: () => PurchaseModule, component: PurchaseComponent, canActivate: [AuthGuard] },
  // { path: 'order', loadChildren: () => OrderModule, component: PurchaseComponent, canActivate: [AuthGuard] },
  // { path: 'setting', loadChildren: () => SettingModule, component: PurchaseComponent,  canActivate: [AuthGuard] },
  // { path: 'login', loadChildren: () => SignInModule, canActivate: [LoginGuard] },
  // { path: "register", loadChildren: () => RegisterModule, canActivate: [LoginGuard] },
  // { path: 'check-email', loadChildren: () => CheckEmailModule, component: CheckEmailComponent, canActivate: [LoginGuard] },
  // // { path: 'profile', loadChildren: () => ProfileModule, canActivate: [AuthGuard], component: PurchaseComponent },
  // // { path: 'register', component: RegisterComponent, canActivate: [LoginGuard] },
  // { path: 'forgot-password', loadChildren: () => ForgetPasswordModule, canActivate:[LoginGuard] },
  // { path: 'reset-password/:token', loadChildren: () => ResetPasswordModule, component: ResetPasswordComponent, canActivate: [LoginGuard] },
  // { path: 'verify/:token', loadChildren: () => EmailVerificationModule, component: EmailVerficationComponent, canActivate:[LoginGuard] },
  // { path: '', redirectTo: 'purchases', pathMatch: 'full'},
  // { path: '', component: TicketComponent, children: [
  //     { path: 'profile', component: ProfileComponent, canActivate:[AuthGuard] },
  //     { path: 'step/1',  component: StepOneComponent },
  //     { path: 'step/2',  component: StepTwoComponent },
  //     { path: 'step/3',  component: StepThreeComponent },
  //     { path: 'finish',  component: FinishComponent ,canActivate:[AuthGuard]},
  //     { path: 'order',  component: MyOrderComponent ,canActivate:[AuthGuard]},
  //     { path: 'order/:id', component: MyOrderDetailComponent ,canActivate:[AuthGuard]},
  //     { path: 'order/:id', canActivate: [AuthGuard], children:[
  //       { path: 'step/1',  component: StepOneComponent },
  //       { path: 'step/2',  component: StepTwoComponent },
  //       { path: 'step/3',  component: StepThreeComponent },
  //     ] },
  //     { path: 'receipt/:id',  component: ReceiptComponent, canActivate:[AuthGuard] }
  //   ]
  // },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' }), CommonModule],
  exports: [RouterModule],
  providers: [AuthGuard, LoginGuard]
})
export class AppRoutingModule { }
